import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Form,
  CardGroup,
  Button,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import { GrPowerReset } from "react-icons/gr";
import {
  getAllSalaries,
  resetSalaryList,
  deleteSalary,
  resetSalaryDelete,
} from "../features/salary/salarySlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import { logout } from "../features/user/userSlice";
import moment from "moment";

const SalaryExpense = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [allSalaries, setAllSalaries] = useState([]);

  const [searchByName, setSearchByName] = useState("");
  const [searchByMonth, setSearchByMonth] = useState("");

  const [selectDateFrom, setSelectDateFrom] = useState("");
  const [selectDateTo, setSelectDateTo] = useState("");

  const { userInfo } = useSelector((state) => state.user);

  const {
    salaries,

    isListLoading,
    isListError,
    isListSuccess,
    listErrorMessage,

    isDeleteError,
    isDeleteLoading,
    isDeleteSuccess,
    deleteErrorMessage,
  } = useSelector((state) => state.salary);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login to Get Access", { position: "top-center" });
      navigate("/login");
    }
    if (userInfo.permissions?.includes("salaryExpense") === false) {
      toast.error("Paknami Keno Koren???", {
        position: "top-center",
      });
      dispatch(logout());
    }
  }, [userInfo, navigate, dispatch]);

  useEffect(() => {
    if (isListError) {
      toast.error(listErrorMessage, { position: "top-center" });
    } else if (isListSuccess) {
      const filteredSalaries = salaries
        .filter((salary) => {
          if (
            searchByName === "" ||
            salary.employeeName
              .toLowerCase()
              .includes(searchByName.toLowerCase())
          ) {
            return true;
          } else {
            return false;
          }
        })
        .filter((salary) => {
          if (
            searchByMonth === "" ||
            salary.monthOfPayment
              .toLowerCase()
              .includes(searchByMonth.toLowerCase())
          ) {
            return true;
          } else {
            return false;
          }
        })
        .filter((salary) => {
          if (selectDateFrom === "" || selectDateTo === "") {
            return true;
          } else {
            return (
              new Date(salary.createdAt) >= new Date(selectDateFrom) &&
              new Date(salary.createdAt) <= new Date(selectDateTo)
            );
          }
        })
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        
      setAllSalaries(filteredSalaries);
    } else {
      dispatch(getAllSalaries());
    }
  }, [
    dispatch,
    isListError,
    isListSuccess,
    listErrorMessage,
    searchByName,
    searchByMonth,
    selectDateFrom,
    selectDateTo,
    salaries,
  ]);

  useEffect(() => {
    if (isDeleteError) {
      toast.error(deleteErrorMessage, { position: "top-center" });
    } else if (isDeleteSuccess) {
      toast.success("Salary Deleted Successfully", { position: "top-center" });
    }
  }, [isDeleteError, isDeleteSuccess, deleteErrorMessage]);

  useEffect(() => {
    return () => {
      dispatch(resetSalaryList());
      dispatch(resetSalaryDelete());
    };
  }, []);

  const handleDelete = (id) => {
    if (
      window.confirm("Are you sure you want to delete this Salary Information?")
    ) {
      dispatch(deleteSalary(id));
      dispatch(resetSalaryList());
    }
  };

  return (
    <Container fluid className="my-4">
      {/* <h2 className="text-center fw-bold mb-4">Salary Information</h2> */}
      <Row className="mb-4">
        <Card
          className="rounded-4 border"
          style={{ backgroundColor: "#e6edf1" }}
        >
          <h2 className="my-3 text-dark text-center fw-bold">
            <span style={{ color: "#5c91dc" }}>Salary</span> Records
          </h2>
        </Card>
      </Row>

      <Row className="my-4">
        {/* Search Options  */}
        <CardGroup className="p-0">
          <Card>
            <Card.Header
              className="text-center fw-bold text-black"
              style={{ backgroundColor: "#74a2e3" }}
              as="h6"
            >
              Search By Name
            </Card.Header>
            <Card.Body>
              <Form>
                <Form.Control
                  type="text"
                  placeholder="Enter Employee Name"
                  name="employeeName"
                  onChange={(e) => setSearchByName(e.target.value)}
                  className="shadow-rounded"
                ></Form.Control>
              </Form>
            </Card.Body>
          </Card>

          <Card>
            <Card.Header
              className="text-center fw-bold text-black"
              style={{ backgroundColor: "#74a2e3" }}
              as="h6"
            >
              Search By Month
            </Card.Header>
            <Card.Body>
              <Form>
                <Form.Control
                  as="select"
                  type="select"
                  placeholder="Select Month"
                  name="monthOfPayment"
                  onChange={(e) => setSearchByMonth(e.target.value)}
                  className="shadow-rounded"
                >
                  <option value="">Select Month</option>
                  <option value="January">January</option>
                  <option value="February">February</option>
                  <option value="March">March</option>
                  <option value="April">April</option>
                  <option value="May">May</option>
                  <option value="June">June</option>
                  <option value="July">July</option>
                  <option value="August">August</option>
                  <option value="September">September</option>
                  <option value="October">October</option>
                  <option value="November">November</option>
                  <option value="December">December</option>
                </Form.Control>
              </Form>
            </Card.Body>
          </Card>

          <Card>
            <Card.Header
              className="text-center fw-bold text-black"
              style={{ backgroundColor: "#74a2e3" }}
              as="h6"
            >
              Search By Date Range
            </Card.Header>

            <Card.Body>
              <Form>
                <Row>
                  <Col>
                    <Form.Group controlId="dateFrom">
                      <Form.Label>From</Form.Label>
                      <Form.Control
                        type="date"
                        onChange={(e) => setSelectDateFrom(e.target.value)}
                        className="shadow-rounded"
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="dateTo">
                      <Form.Label>To</Form.Label>
                      <Form.Control
                        type="date"
                        onChange={(e) => setSelectDateTo(e.target.value)}
                        className="shadow-rounded"
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Card.Body>

            <Card.Footer>
              <Col className="d-flex justify-content-end">
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    setSelectDateFrom("");
                    document.getElementById("dateFrom").value = "";
                    setSelectDateTo("");
                    document.getElementById("dateTo").value = "";
                  }}
                >
                  <GrPowerReset className="mb-1" /> Reset
                </Button>
              </Col>
            </Card.Footer>
          </Card>
        </CardGroup>
      </Row>

      <Row>
        {/* Table */}
        <Card style={{ backgroundColor: "#74a2e3" }}>
          <Card.Header
            className="text-center text-black p-3 fw-bold"
            style={{ backgroundColor: "#74a2e3" }}
            as="h5"
          >
            Salary List
          </Card.Header>
          <Table responsive bordered hover>
            <thead className="text-center">
              <tr>
                <th>Employee Name</th>
                <th>Paid Amount</th>
                <th>Month</th>
                <th>Delete</th>
                {/* <th>Payment Status</th> */}
              </tr>
            </thead>

            {isListLoading ? (
              <Loader />
            ) : (
              <>
                <tbody className="text-center">
                  {allSalaries.map((salary) => (
                    <tr key={salary._id} style={{ cursor: "pointer" }}>
                      <td style={{ padding: "0px" }}>{salary.employeeName}</td>
                      <td style={{ padding: "0px" }}>{salary.amount}</td>
                      <td style={{ padding: "0px" }}>
                        {/* newest entries will show first */}
                        {moment(salary.createdAt).format("MMMM")}
                        {/* {salary.monthOfPayment} */}
                      </td>

                      {userInfo?.userType === "admin" ? (
                        <>
                          <td style={{ padding: "0px" }}>
                            <Button
                              onClick={() => handleDelete(salary._id)}
                              variant="danger btn-sm"
                            >
                              <MdDelete />
                            </Button>
                          </td>
                        </>
                      ) : (
                        <>
                          <td style={{ padding: "0px" }}>
                            <Button
                              // onClick={() => handleDelete(salary._id)}
                              variant="danger btn-sm"
                              disabled
                            >
                              <MdDelete />
                            </Button>
                          </td>
                        </>
                      )}
                      {/* <td>{salary.paymentStatus}</td> */}
                    </tr>
                  ))}
                </tbody>
              </>
            )}
          </Table>
        </Card>
      </Row>
    </Container>
  );
};

export default SalaryExpense;
